export default __webpack_public_path__ + "static/media/list-1.059fbbe5.svg";